import { lastICMessageTime, setLastICMessageTime } from "../client";
import { icLogHistory, capLogNodes } from "./logHistory";

/**
 * Appends a message to the in-character chat log.
 * @param {string} msg the string to be added
 * @param {string} name the name of the sender
 */
export function appendICLog(
  msg: string,
  showname = "",
  nameplate = "",
  time = new Date(),
  color = "",
  parsed: HTMLElement[] | null = null,
) {
  const entry = document.createElement("p");
  const shownameField = document.createElement("span");
  const nameplateField = document.createElement("span");
  const textField = document.createElement("span");
  nameplateField.className = "iclog_name iclog_nameplate";
  nameplateField.appendChild(document.createTextNode(nameplate));

  shownameField.className = "iclog_name iclog_showname";
  if (showname === "" || !showname) {
    shownameField.appendChild(document.createTextNode(nameplate));
  } else {
    shownameField.appendChild(document.createTextNode(showname));
  }

  textField.className = "iclog_text";
  let cloned = false;
  if (parsed && parsed.length > 0) {
    try {
      for (const span of parsed) {
        textField.appendChild(span.cloneNode(true));
      }
      cloned = true;
    } catch (e) {
      console.error("IC log markup clone failed", e);
      cloned = false;
    }
  }
  if (!cloned) {
    if (color) {
      textField.classList.add(`text_${color}`);
    }
    textField.appendChild(document.createTextNode(msg));
  }

  entry.appendChild(shownameField);
  entry.appendChild(nameplateField);
  entry.appendChild(textField);

  // Only put a timestamp if the minute has changed.
  let timeLabel = "";
  if (lastICMessageTime.getMinutes() !== time.getMinutes()) {
    timeLabel = time.toLocaleTimeString(undefined, {
      hour: "numeric",
      minute: "2-digit",
    });
    const timeStamp = document.createElement("span");
    timeStamp.className = "iclog_time";
    timeStamp.innerText = timeLabel;
    entry.appendChild(timeStamp);
  }

  const clientLog = document.getElementById("client_log")!;
  clientLog.appendChild(entry);

  // Record the entry in the unbounded text history (for /save_chatlog), then
  // cap the rendered DOM so long sessions don't accumulate thousands of nodes.
  icLogHistory.push({
    showname: showname === "" || !showname ? nameplate : showname,
    text: textField.textContent ?? "",
    time: timeLabel,
  });

  if (
    clientLog.scrollTop + clientLog.offsetHeight + 120 >
    clientLog.scrollHeight
  )
    clientLog.scrollTo(0, clientLog.scrollHeight);

  capLogNodes(clientLog);

  setLastICMessageTime(new Date());
}
